// Importing the AlbumForm component
import AlbumForm from "./AlbumForm";

// Functional component AddAlbum
const AddAlbum = () => {

  // Rendering the AlbumForm component

  return <AlbumForm />;
};

// Exporting AddAlbum as the default export
export default AddAlbum;